import { render, staticRenderFns } from "./IconYoutube.vue?vue&type=template&id=ff26b55c&"
import script from "./IconYoutube.vue?vue&type=script&lang=js&"
export * from "./IconYoutube.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports